// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary {
  background-color: #AB2F40;
  border: none;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  height: 40px;
  width: 204px;
  font-size: 16px;
  font-weight:  800;

}

.register-button {
  background-color: #AB2F40;
  border: none;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  width: 204px;
  height: 40px;
}

button.primary.save-btn.disable {
  background-color: #ab2f409e;
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/styles.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;;AAEnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".primary {\n  background-color: #AB2F40;\n  border: none;\n  color: white;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  height: 40px;\n  width: 204px;\n  font-size: 16px;\n  font-weight:  800;\n\n}\n\n.register-button {\n  background-color: #AB2F40;\n  border: none;\n  color: white;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  width: 204px;\n  height: 40px;\n}\n\nbutton.primary.save-btn.disable {\n  background-color: #ab2f409e;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
